import React,{useState, useEffect} from 'react';
import './sign-up.scss';

import Button from '../../../elements/button/button';
import PasswordInput from '../../../elements/password-input/password-input';
import {request,unSubRequest} from '../../../../utils/request'
import { Link } from 'react-router-dom';
import Config from '../../../../config/config';
import Checkbox from '../../../elements/checkbox/checkbox';
import {toast} from 'react-toastify';
import Recaptcha from 'react-google-recaptcha';
import * as NumberUtil from '../../../../utils/number';
import {t} from '../../../../translations/i18n';

const SignUp = ({successCallback,checkUpdateFunc}) => {

  const [recaptchaKey,setRecaptchaKey] = useState(1);
  const [recaptchaValue,setRecaptchaValue] = useState("");
  const [username,setUsername] = useState("");
  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [check,setCheck] = useState(false);
  const [loading,setLoading] = useState(false);
  const [buttonStatus,setButtonStatus] = useState("");
  const [success,setSuccess] = useState(false);
  const [referralInfo,setReferralInfo] = useState(null);

  useEffect(() => {
    handleReferralCode();
    return () => {
      unSubRequest("affiliate");
      unSubRequest("sign-up");
    }
  },[]);

  useEffect(() => {
    setButtonStatus((loading)?"loading":"");
  },[loading]);

  useEffect(() => {
    if(checkUpdateFunc) checkUpdateFunc(check);
  },[check,checkUpdateFunc])

  const handleSubmit = (e) => {
    e.preventDefault();
    if(!check){
      toast.error(t('entry.signUpCheckDisclaimer'));      
      return;
    }

    if(username !== "" && email !== "" && password !== ""){

      const data = {
        username,
        email,
        password,
        recaptchaValue,
      };
      if(localStorage.getItem("device")){
        data.deviceToken = localStorage.device;
      }
      if(localStorage.getItem("referralCode")){
        data.referralCode = localStorage.referralCode;
      }

      setLoading(true);
      request("sign-up","/user","POST", data, {
        then: function(res){
          let results = res.data.res;
          // console.log("results",results);
          if(results.newDeviceToken) localStorage.setItem("device",results.newDeviceToken);
          setSuccess(true);
        },
        catch: function(err){ toast.error(err.message)},
        finally: function(){
          let randInt = NumberUtil.getRandomInt(2,99999999);
          setRecaptchaKey(randInt);
          setRecaptchaValue("");
          setLoading(false);
        }
      });
    }
  }

  const handleReferralCode = () => {
    if(localStorage.getItem("referralCode")){
      const referralCode = localStorage.getItem("referralCode");
      request("affiliate","/affiliate/"+referralCode,"GET", {}, {
        then: function(res){
          let results = res.data.res;
          let newReferralInfo = null
          if(results.useDisplay){
            newReferralInfo = results;
          }
          setReferralInfo(newReferralInfo)
        },
        catch: function(err){ 
          localStorage.removeItem("referralCode");
          toast.error(err.message)
        },
        finally: function(){}
      });
    }
  }

  if(success){
    if(successCallback !== undefined){
      successCallback();
    }
    return(
      <div className="sign-up">
        <div className="success">
          <p>{t('entry.signupSuccessNice')}</p>
          <p>{t('entry.signupSuccessCheckJunkMail')}</p>
          <p>{t('entry.signupSuccessDidntReceiveEmail')} </p>
          <p>{t('entry.signupSuccessAlreadyHaveAccount')} </p>
          {/* <p>{t('entry.signupSuccessDidntReceiveEmail')} <Link to="/verify-email">Resend Verification Email</Link></p>
          <p>{t('entry.signupSuccessAlreadyHaveAccount')} <Link to="/reset-password">Reset Password</Link></p> */}
        </div>
      </div>
    )
  }

  return (
    <div className="sign-up">
      <form onSubmit={handleSubmit}>
        <label>{t('entry.username')}</label>
        <input disabled={loading} type="text" placeholder={t('entry.username')} defaultValue={username} onChange={(e) => {setUsername(e.target.value)}}/>
        <label>{t('entry.email')}</label>
        <input disabled={loading} type="email" placeholder={t('entry.email')} defaultValue={email} onChange={(e) => {setEmail(e.target.value)}}/>
        <label>{t('entry.password')}</label>
        <PasswordInput disabled={loading} placeholder={t('entry.password')} defaultValue={password} onChange={(e) => {setPassword(e.target.value)}}/>
        <label className="legal">
          <Checkbox value={check} setValue={setCheck} />
          <span>{t('entry.termsOfServiceAgreement',{appName: Config.Common.AppName, tosLink: <a href="/terms-of-use" target="_blank" rel="noopener noreferrer">{t('entry.termsOfService')}</a>})}</span>
        </label>
        <Recaptcha key={recaptchaKey}
            className="recaptcha" sitekey={Config.Keys.RecaptchaPubKey} 
            onChange={(value) => {setRecaptchaValue(value)}}
            onExpired={() => {setRecaptchaValue("")}}/>
        <Button disabled={loading} type="submit" status={buttonStatus} value={t('entry.createAccount')}/>
      </form>
      {(referralInfo)?
      <div className="referral-info">
        <h4>Referral by {referralInfo.display}</h4>
        <p className="note">By signing up using their referral link you're directly supporting them.</p>
      </div>
      :null}
    </div>
  );
};

export default SignUp;